import { render, staticRenderFns } from "./maper.vue?vue&type=template&id=2f237f32&"
import script from "./maper.vue?vue&type=script&lang=js&"
export * from "./maper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "maper.vue"
export default component.exports